import {
  w1 as arrayCopy,
  r9 as RuntimeException,
  s as IntCompanionObject_getInstance,
  k9 as IllegalStateException,
  c2 as copyOf,
  ga as VOID,
  p5 as classMeta,
  o6 as setMetadataFor,
  q6 as toLong,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class ByteArrayBuilder {
  constructor(data, size, allowGrow) {
    size = size === VOID ? data.length : size;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.z34_1 = data;
    this.a35_1 = allowGrow;
    this.b35_1 = size;
  }
  static c35(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    var $this = new ByteArrayBuilder(new Int8Array(initialCapacity), 0);
    return $this;
  }
  o() {
    return this.b35_1;
  }
  d35(array, offset, len) {
    ensureCount(this, len);
    arraycopy(array, offset, this.z34_1, this.b35_1, len);
    var tmp0_this = this;
    tmp0_this.b35_1 = tmp0_this.b35_1 + len | 0;
  }
  e35(v) {
    ensure(this, this.b35_1 + 1 | 0);
    var tmp = this.z34_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.b35_1;
    tmp0_this.b35_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v;
  }
  f35() {
    return copyOf(this.z34_1, this.b35_1);
  }
}
//endregion
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var tmp0_copyInto = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, tmp0_copyInto);
}
function extract(_this__u8e3s4, offset, count) {
  return (_this__u8e3s4 >>> offset | 0) & mask(count);
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function insert(_this__u8e3s4, value, offset, count) {
  var mask_0 = mask(count);
  var clearValue = _this__u8e3s4 & ~(mask_0 << offset);
  return clearValue | (value & mask_0) << offset;
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function ensure($this, expected) {
  if ($this.z34_1.length < expected) {
    if (!$this.a35_1)
      throw RuntimeException.u6('ByteArrayBuffer configured to not grow!');
    var newSize = imul($this.z34_1.length + 7 | 0, 5);
    var realNewSize = newSize < 0 ? IntCompanionObject_getInstance().MAX_VALUE / 2 | 0 : newSize;
    if (newSize < 0 ? expected > realNewSize : false) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.y1("ByteArrayBuffer can't grow that much");
    }
    var tmp = $this;
    var tmp_0 = $this.z34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    tmp$ret$0 = Math.max(expected, realNewSize);
    tmp.z34_1 = copyOf(tmp_0, tmp$ret$0);
  }
}
function ensureCount($this, count) {
  ensure($this, $this.b35_1 + count | 0);
}
function readS16(_this__u8e3s4, o, little) {
  return little ? readS16LE(_this__u8e3s4, o) : readS16BE(_this__u8e3s4, o);
}
function readS16LE(_this__u8e3s4, o) {
  var tmp$ret$0;
  // Inline function 'korlibs.memory.read16LE' call
  tmp$ret$0 = u8$accessor$nv62cx(_this__u8e3s4, o + 0 | 0) << 0 | u8$accessor$nv62cx(_this__u8e3s4, o + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function readS16BE(_this__u8e3s4, o) {
  var tmp$ret$0;
  // Inline function 'korlibs.memory.read16BE' call
  tmp$ret$0 = u8$accessor$nv62cx(_this__u8e3s4, o + 1 | 0) << 0 | u8$accessor$nv62cx(_this__u8e3s4, o + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function u8(_this__u8e3s4, o) {
  return _this__u8e3s4[o] & 255;
}
function u8$accessor$nv62cx(_this__u8e3s4, o) {
  return u8(_this__u8e3s4, o);
}
var MINUS_ZERO_F;
function clamp(_this__u8e3s4, min, max) {
  return _this__u8e3s4 < min ? min : _this__u8e3s4 > max ? max : _this__u8e3s4;
}
function toIntClamp(_this__u8e3s4, min, max) {
  min = min === VOID ? IntCompanionObject_getInstance().MIN_VALUE : min;
  max = max === VOID ? IntCompanionObject_getInstance().MAX_VALUE : max;
  if (_this__u8e3s4.gd(toLong(min)) < 0)
    return min;
  if (_this__u8e3s4.gd(toLong(max)) > 0)
    return max;
  return _this__u8e3s4.md();
}
var POINTER_SIZE;
var LONG_SIZE;
//region block: post-declaration
setMetadataFor(ByteArrayBuilder, 'ByteArrayBuilder', classMeta);
//endregion
//region block: init
MINUS_ZERO_F = -0.0;
POINTER_SIZE = 4;
LONG_SIZE = 8;
//endregion
//region block: exports
export {
  ByteArrayBuilder as a,
  arraycopy as b,
  clamp as c,
  extract as d,
  insert as e,
  readS16 as f,
  toIntClamp as g,
};
//endregion

//# sourceMappingURL=korge-root-kmem.mjs.map
